import {
    AccessorsMutatorsDecorator,
} from '../../helpers';
import {TranslatableModel} from "./translatable-model";

/**
 * @class User
 * @property {number} id
 * @property {string} name
 * @property {string} email
 * @property {string} role
 */
export class UserTranslatable extends TranslatableModel {


    get name_ar() {

        return this.name
    }

}

AccessorsMutatorsDecorator('id', 'name', 'email', 'role', 'roles', 'propertyRole', 'properties', 'confirmed',
    'property_status', 'activation_status', 'status', 'permissions', 'account_id', 'active_properties', 'inproperties', 'mabeet_role', 'house_accounts')(UserTranslatable);



// WEBPACK FOOTER //
// ./src/pms-api/models/user-translatable.model.js